module.exports = __webpack_public_path__ + "static/media/ms_sans_serif_bold.cb1c7473.woff2";